import styled from 'styled-components';
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { utilTransNum } from '../../../func/Function';

const RealDealListTransition = ({ data, saleTab, yearTab }: any) => {
  const chartData = data.map((item: any) => ({
    date: item.mon,
    price: Number(item.prc),
    price2: Number(item.dealprice),
    // priceCombined: `${Number(item.prc)}/${Number(item.prc)}`,
  }));

  return (
    <GraphBox>
      <GraphDataBox>
        <ResponsiveContainer width="100%" height={156}>
          <LineChart
            data={chartData}
            margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="0.6">
                <stop
                  offset="5%"
                  stopColor="rgba(0, 138, 255, 1)"
                  stopOpacity={1}
                />
                <stop
                  offset="95%"
                  stopColor="rgba(0, 138, 255, 1)"
                  stopOpacity={0}
                />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="#ccc" strokeWidth={1} vertical={false} />
            <XAxis
              dataKey="date"
              tick={{
                color: 'rgba(23,30,38,0.56)',
                fontSize: 11,
                fontFamily: 'Pretendard-Medium',
              }}
              tickLine={false}
              axisLine={false} // X축 선을 제거
              interval={yearTab === 'A' ? 6 : yearTab === 'C' ? 1 : 0}
              // scale="point" // X축 간격을 균일하게 설정
              minTickGap={1} // 최소 간격 설정
              padding={{ right: 20 }} // 오른쪽 여백 추가
            />
            <YAxis
              axisLine={false} // Y축 선을 제거
              tick={{
                color: 'rgba(23,30,38,0.56)',
                fontSize: 11,
                fontFamily: 'Pretendard-Medium',
                fontWeight: '400',
              }}
              tickLine={false}
              tickFormatter={(value) => utilTransNum(value)}
            />
            <Tooltip
              labelFormatter={(label) => `${label}`}
              formatter={(value) => `${utilTransNum(Number(value))}원`}
              contentStyle={{
                fontFamily: 'Pretendard-Medium', // 폰트 스타일 지정
                fontSize: '12px', // 폰트 크기 지정
                color: '#171E26', // 폰트 색상 지정
              }}
              labelStyle={{
                fontFamily: 'Pretendard-Bold', // 라벨 폰트 스타일
                fontSize: '12px', // 라벨 폰트 크기
                color: '#171E26', // 라벨 폰트 색상
              }}
            />
            <Line
              type="monotone"
              dataKey={saleTab === 'M' ? 'price' : 'price'}
              stroke="rgba(0, 138, 255, 1)"
              fillOpacity={1}
              fill="url(#colorPv)"
              name={
                saleTab === 'M' ? '월세' : saleTab === 'D' ? '전세' : '매매'
              }
              strokeWidth={2}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </GraphDataBox>
    </GraphBox>
  );
};

export default RealDealListTransition;

const GraphBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 156px;
  justify-content: space-between;
  padding-top: 4px;
`;

const GraphDataBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 156px;
`;
